var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDogDrooling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.2 38.2",
    style: {
      enableBackground: "new 0 0 66.2 38.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C10000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    className: "st0",
    d: "M34,34.6c0.6,0,1.3-0.2,1.1-0.4c-0.1-0.2-1-0.3-1.5-0.5C33,33.5,33.3,33,34,32.8 c1.6-0.5,4.5-0.3,6.4-0.4c0.4,0,0.7,0,1.1-0.1c0.3-0.1,0.5-0.2,0.4-0.3c-0.6-0.5,2.2-0.5,2.9-0.6c1.7-0.2,3.5-0.3,5.3-0.2 c0.7,0.1,1.3,0.3,2,0.4c2.3,0.4,5.1,0.1,7.7,0.3c0.7,0,1.3,0.2,1.9,0.4c0.7,0.3,0,0.5,0,0.8c-0.1,0.3,1,0.6,1.8,0.7 c0.8,0.1,1.6,0.2,2.3,0.4c0.8,0.4,0.2,0.9-0.9,1.2c-1.3,0.2-2.5,0.3-3.8,0.2c-1.3-0.1-2.6,0-3.9,0.1c0.4,0.2,0.3,0.5-0.1,0.7 c-1,0.3-2,0.4-3,0.3c-1.4,0-2.8,0-4.1,0c-1.6,0-3.3,0-4.9-0.1c-1.5,0-3.1-0.1-4.6-0.4c-0.6-0.2,0.1-0.3-0.1-0.5 c-0.3-0.1-0.7-0.2-1.1-0.2c-0.7,0-1.4,0.1-2.1,0.1c-1.2,0.1-2.5,0.1-3.7,0c-0.9-0.1-2.8-0.5-1.9-1C32.4,34.7,33.2,34.6,34,34.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    transform: "translate(0 3.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    className: "st0",
    d: "M35.7,5.1c-0.9-1.6-1.4-3.3-1.6-5.1c0,0-19.5,7.6-21.4,27.8c-2.9,0.1-5.9,2.1-8.4,2.7 c-4.6,1.1-7.1,3.2,0.7,3.2c3.1-0.3,6.1-0.9,9-1.9c-0.1,0.7-0.1,1.4,0,2.1c0.1,0.2,0.8,0.4,1.8,0.5c4,0.5,13.4,0.2,14-1 c0.3-0.5,0.1-1.6-1.2-2c-2.2-0.8-6.1-0.8-5.4-1.3c1-0.7,3.2-0.8,4.1-4.4c0.8-3.2,4.7-4.3,6.3-5.5l1.3,12.5 c0.1,0.9,0.9,1.6,1.8,1.6c0,0,0.1,0,0.1,0c1-0.1,1.7-0.9,1.7-1.9c0,0-1.5-20.5,0.8-23.7C39.6,8.4,37.2,7.8,35.7,5.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    className: "st0",
    d: "M52.1,11.1c0,0,3.3,1.5,4,2.6c0.4,0.7,0.2,1.6-0.5,2.1c-0.6,0.4-1.5,0.3-2-0.3 c-0.6-0.7-0.3-1.4-0.5-2.3C53,12.4,52.6,11.7,52.1,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    className: "st0",
    d: "M50,19.2c0,0-0.6,3.3-1.5,7.9c-0.4,2.3,2.5,2.5,2.5,1C51,24.9,49.9,23.3,50,19.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    transform: "translate(45.559 33.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    className: "st0",
    d: "M0,0.4c0.4-0.1,0.8-0.2,1.2-0.3C1.6,0.1,2,0,2.4,0c0.4,0,0.8,0,1.3,0.1 c0.4,0.1,0.8,0.2,1.1,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.4,0-0.8,0-1.2-0.1c-0.4,0-0.7-0.1-1.1-0.1s-0.8,0-1.2,0 C0.8,0.3,0.4,0.4,0,0.4C0,0.4,0,0.4,0,0.4C0,0.4,0,0.4,0,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    transform: "translate(40.583 35.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    className: "st0",
    d: "M0.1,0C0.5,0.1,1,0.1,1.4,0.2s0.9,0.1,1.4,0.1c1,0,1.9,0,2.9,0s1.9,0,2.9,0s1.9,0,2.9,0.1 c0,0,0,0,0,0s0,0,0,0c-0.9,0.1-1.9,0.2-2.9,0.2s-1.9,0-2.9,0S3.8,0.5,2.8,0.4c-0.5,0-1,0-1.5-0.1C0.9,0.3,0.4,0.2,0,0.1 C0,0,0,0,0.1,0C0.1,0,0.1,0,0.1,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    className: "st0",
    d: "M44.7,9.5h6.7l0.7-0.5c2-4.4,1.7-5.5,0.4-6.1c-1.3-0.6-8-0.4-12.3-0.2c-0.2,0-0.4-0.1-0.5-0.2 C39,2,38,1.2,37.2,0.5c-1.4-1.2-1.4,0.4-1.4,0.4l0.3,1.1c0.1,0.4-0.1,0.8-0.5,0.9h0c-0.3,0.1-0.5,0.4-0.5,0.7 c0.1,2.1,0.9,4.1,2.2,5.6c1.4,1.9,3.4,3.3,5.7,3.8c0.1,0,0.2,0,0.3,0c1.6-0.3,3.2-0.7,4.7-1.1c0.4-0.1,0.6-0.6,0.5-1 c-0.1-0.3-0.3-0.5-0.6-0.5L44.7,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    className: "st0",
    d: "M50.2,10.9c0,0,0.8,0.3,0.7,2.3s-1.8,3.9-0.9,5s2.3,0.1,2.4-1.2S51.9,12.1,50.2,10.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDogDrooling);
export default __webpack_public_path__ + "static/media/icon-dog-drooling.8cc2d213760cb81aeafc413c1ff750dd.svg";
export { ForwardRef as ReactComponent };